import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import TopNav from './TopNav'
import { HomePath } from '../home-path'
import { useEffect } from 'react';
import Median from 'median-js-bridge';

export default function Navbar() {
    const navigate = useNavigate();

    useEffect(() => {
        Median.jsNavigation.url.addListener((data) => {
            const url = new URL(data.url);
            if (url.pathname.startsWith(HomePath)) {
                navigate(url.pathname);
            } else {
                window.location.href = data.url;
            }
        });
    }, []);

  return (
    <>
    <TopNav />
    <div id="botNav" className="h-fit w-full bg-gray-50">
        <div className="mxw py-4 flex justify-between items-center">
            <ul className="flex justify-center space-x-2 text-sm md:text-md lg:text-lg tracking-tighter">
                <li className="font-medium">
                    <Link to={HomePath + "/home"}>Home</Link>
                </li>
                <li className="font-medium">
                    <Link to={HomePath + "/shop"}>Shop</Link>
                </li>
                <li className="font-medium">
                    <Link to={HomePath + "/discover"}>Discover</Link>
                </li>
            </ul>
            <div className="flex items-center text-sm md:text-md lg:text-lg font-medium space-x-2">
                <Link className="hidden md:inline-block" to={HomePath + "/orders"}>Orders</Link>
                <Link to={HomePath + "/favourites"} className="inline-flex items-center space-x-2">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4 md:w-5 md:h-5 lg:w-6 lg:h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" />
                        </svg>
                    </span>
                </Link>
                <Link to={HomePath + "/cart"}>
                    <div className="relative">
                        <div className="absolute -top-2 md:-top-3 -right-3 h-4 w-4 md:h-5 md:w-5 bg-rose-500 text-white font-medium rounded-full grid place-items-center text-xs md:text-sm">2</div>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-4 w-4 md:w-5 md:h-5 lg:w-6 lg:h-6">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M15.75 10.5V6a3.75 3.75 0 10-7.5 0v4.5m11.356-1.993l1.263 12c.07.665-.45 1.243-1.119 1.243H4.25a1.125 1.125 0 01-1.12-1.243l1.264-12A1.125 1.125 0 015.513 7.5h12.974c.576 0 1.059.435 1.119 1.007zM8.625 10.5a.375.375 0 11-.75 0 .375.375 0 01.75 0zm7.5 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
                        </svg>
                    </div>
                </Link>
            </div>
        </div>
    </div>
    </>
  )
}
